import React from "react"

import { Portlet } from "@/components"
import { Grid, makeStyles } from "@material-ui/core"
import { Skeleton } from "@material-ui/lab"

const useStyles = makeStyles(theme => ({
	customRadius: {
		borderRadius: theme.spacing(0.5)
	}
}))

export const GoogleDrivePluginSettingsMenuSkeleton = () => {
	const classes = useStyles()

	return (
		<Portlet
			elevation={1}
		>
			<Grid
				container
				direction="column"
				spacing={4}
			>
				<Grid item>
					<Grid container justifyContent="space-between">
						<Grid item xs={8}>
							<Skeleton className={classes.customRadius} variant="rect" width="100%" height={90} />
						</Grid>
						<Grid item xs={2}>
							<Skeleton className={classes.customRadius} variant="circle" width="100%" height={40} />
						</Grid>
					</Grid>
				</Grid>

				<Grid item>
					<Grid container justifyContent="flex-end">
						<Grid item xs={1}>
							<Skeleton className={classes.customRadius} variant="rect" width="100%" height={55} />
						</Grid>
					</Grid>
				</Grid>
			</Grid>
		</Portlet>
	)
}

export const GoogleDrivePluginSkeleton = () => {
	const classes = useStyles()

	return (
		<Grid
			container
			direction="column"
			spacing={3}
		>
			<Grid item>
				<Grid container alignItems="center" justifyContent="space-between">
					<Grid item>
						<Skeleton className={classes.customRadius} variant="rect" width={300} height={20} />
					</Grid>

					<Grid item>
						<Skeleton className={classes.customRadius} variant="rect" width={200} height={38} />
					</Grid>
				</Grid>
			</Grid>

			<Grid item>
				<Skeleton className={classes.customRadius} variant="rect" width="100%" height={48} />
			</Grid>

			<Grid item>
				<GoogleDrivePluginSettingsMenuSkeleton />
			</Grid>
		</Grid>
	)
}
